<template>
    <div v-if="user">
        <div class="panel panel-success"  >
            <!-- Default panel contents -->
            <div class="panel-heading">
                <i class="fa fa-bars" aria-hidden="true"></i> MENU REPETIDOR
            </div>
            <div class="panel-body" v-if="user.level < 5" >
                <p>
                    <a :href="'#/repetidor/novo'" class="btn btn-info btn-block">NOVO REPETIDOR</a>
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        repetidor_id: null
    },
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    }
};
</script>
